import { useLang } from "@/context/LanguageContext";
import { LOGO } from "@/data/content";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-ink py-12">
      <div className="max-w-[88rem] mx-auto px-5 md:px-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <img src={LOGO} alt="Said Kalil" className="h-11 w-auto object-contain" />
        <span className="font-medium text-sm text-white/50">© {new Date().getFullYear()} — {t.footer}</span>
      </div>
    </footer>
  );
};
